import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { SimpleCheckOptionComponent } from './simple-check-option/simple-check-option.component';

@Component({
  selector: 'multi-check-field',
  templateUrl: './multi-check-field.component.html',
  styleUrls: ['./multi-check-field.component.scss']
})
export class MultiCheckFieldComponent implements AfterContentInit {
  @ContentChildren(SimpleCheckOptionComponent) options!: QueryList<SimpleCheckOptionComponent>;

  ngAfterContentInit() {
    // Logic to handle the selected options
  }
}